// extracted by mini-css-extract-plugin
export var activityContainer = "_ku-0";
export var typingIndicatorContainer = "_ku-1";
export var typingIndicatorDot = "_ku-2";
export var wave = "_ku-3";